import styled from "styled-components";
import { sizes } from "styles";

export const OnGoingClassCardContainer = styled.section``;

export const OnGoingClassCardTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.white};
  line-height: 1;

  &:before {
    content: "";
    width: 20px;
    height: 20px;
    border-radius: 100%;
    display: inline-block;
    font-size: ${({ theme }) => theme.fontSizes["2xl"]};
    background-color: ${({ theme }) => theme.colors.magenta[500]};
    margin: 0 16px 0 0;
  }
`;

export const OnGoingClassCardTitleFreeUser = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1;

  &:before {
    content: "";
    width: 20px;
    height: 20px;
    border-radius: 100%;
    display: inline-block;
    font-size: ${({ theme }) => theme.fontSizes["2xl"]};
    background-color: ${({ theme }) => theme.colors.magenta[500]};
    margin: 0 16px 0 0;
  }
`;

export const OnGoingClassCard = styled.div<{ isHeroSection?: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0 0 8px 8px;

  ${({ isHeroSection }) =>
    !isHeroSection &&
    `
    border-radius: 8px;
  `}

  box-shadow: 0px 0px 32px ${({ theme }) => theme.colors.transparent.white10};
  display: flex;
  overflow: hidden;
  width: ${sizes.kelasLive.onGoingClassCardWidth};
`;

export const OnGoingClassCardImageContainer = styled.div`
  flex-basis: 40%;
`;

export const OnGoingClassCardImageWrapper = styled.figure`
  margin: 0;
  padding: 100% 0 0 0;
  position: relative;

  &:before {
    content: "• Live";
    display: inline-block;
    text-transform: uppercase;
    font-size: ${({ theme }) => theme.fontSizes.lg};
    font-family: ${({ theme }) => theme.fonts.primary};
    line-height: 1;
    padding: 4px;
    color: ${({ theme }) => theme.colors.magenta[500]};
    background-color: ${({ theme }) => theme.colors.magenta[100]};
    position: absolute;
    top: 16px;
    left: 16px;
    z-index: 1;
    font-weight: bold;
    letter-spacing: 1px;
  }
`;
export const OngoingClassCardDetails = styled.div`
  padding: 40px;
  position: relative;
  width: 100%;
`;

export const OngoingClassCardTopicsContainer = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const OngoingClassCardDetailsHeading = styled.h3`
  margin: 16px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
`;

export const OngoingClassCardDetailsContent = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OngoingClassCardDetailsTeacherContainer = styled.div``;

export const OngoingClassCardDetailsTeacher = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  color: ${({ theme }) => theme.colors.black};
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const OngoingClassCardInfoItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const OngoingClassCardInfoItem = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  margin: 0;
  &:not(:last-child) {
    &:after {
      content: "•";
      margin: 0 4px;
      font-size: ${({ theme }) => theme.fontSizes["md"]};
      color: ${({ theme }) => theme.colors.neutral[600]};
    }
  }
`;

export const OngoingClassCardProgressContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const OngoingClassCardProgressBarContainer = styled.div`
  width: 100%;
  height: 10px;
  position: relative;
  background: ${({ theme }) => theme.colors.green[100]};
`;

export const OngoingClassCardProgressBarActive = styled.div<{ value: number }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${({ value }) => `${value}%`};
  background-color: ${({ theme }) => theme.colors.green[600]};
`;
export const OngoingClassCardProgressMessage = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.green[600]};
  font-weight: bold;
  margin: 0 0 16px 0;
  padding: 0 40px;
`;

export const ClassTagContainer = styled.div<{ backgroundColor: string }>`
  position: relative;
  border-radius: 8px 8px 0 0;
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  color: ${({ theme }) => theme.colors.brand["800"]};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: bold;
`;
